import {turpial} from "./turpial";
const AppForms = {
    formsCount: [], // where forms retrieve will be stored
    element: function(el){
        if(typeof el === "string"){
            el = document.getElementById(el);
        }
        return {
            name: el.name,
            value: el.value
        }				
    },
    elementsJoin: function(elements){
        var newStructure = [];
        elements.forEach(function(el){
            newStructure[el.name] = el.value;
        });
        return newStructure;
    },		
    tags: {
        retrieve: function(props){
            props = turpial.un(props, {});
            var helperElements = document.querySelectorAll(".PencilTagsHelperConstructor");
            helperElements = pencil.concat(helperElements);
            if(helperElements.length === 0){ return; }
            helperElements.forEach(function( helperElement ){
                var input = helperElement.getAttribute("data-input");
                input = turpial.find( input );
                if(input.getAttribute("data-retrived") === true){ return; }
                if(input === null){ return; }

                var tags = helperElement.innerText.split(",");
                tags.forEach(function( tag ){
                    if(tag === ""){ return; }
                    if(tag === null){ return; }
                    if(tag === "null"){ return; }
                    input.value = tag;
                    pencil.form.tags.attach(input, "attaching", {classInput: props.classInput});
                    input.value = "";
                })
                input.setAttribute("data-retrived", true);
            })
        },
        remove: function( element ){
            var deleteButton = element;
            var value = deleteButton.querySelector("span").innerText;
            var target = deleteButton.getAttribute("data-elements");
            target = turpial.find(target);
            var tags = target.innerText;
            var newElements = [];
            tags.split(",").forEach(function( tag ){
                if(tag !== value){
                    newElements.push( tag )
                }
            })
            newElements = newElements.join(",");
            target.innerText = newElements;
            deleteButton.parentNode.parentNode.remove();
        },
        attach: function(element, event, props){
            if(event.key === "Enter" || event.key === "," || event === "attaching"){ 
                // just go ahead!
            }else{ return; }
            if(element.value === ""){ return; }
            props = turpial.un(props, {});
            if(typeof element.id !== "string"){
                console.warn("Set an id for input tags element: ");
                console.log(element);
                return;
            }				
            var id = `${element.id}--pencilTagsInput`;
            var helperInput = turpial.find(id);
            var idTags = `${element.id}--pencilTagsElements`;
            var helperTags = turpial.find( idTags );				
            if(helperInput === null){
                // insert input
                turpial.insert(element, `<div data-type="tags" id="${id}" class="is-hidden"></div>`, "before");
                // insert fisrt value
                turpial.insert(element, `<div style="margin-top:20px;" id="${idTags}" class="tags-pencilTagsElements field is-grouped is-grouped-multiline"></div>`, "after");

                helperInput = turpial.find(id);
                helperInput.innerText = `${element.value}`;
            }else{
                // update values
                var isInserted = false;
                helperInput.innerText.split(",").forEach(function(el){
                    // if element was inserted
                    console.log(el)
                    if(el === element.value){ isInserted = true }
                })
                if(isInserted === true){ return; }
                helperInput.innerText = `${helperInput.innerText},${element.value}`;
            }
            var Class = turpial.un(props.classInput, "");
            if(Class !== ""){
                helperInput.classList.add(props.classInput);
            }				

            var templateTags = function(value, color){
                return `<div class="control">
                        <div class="tags has-addons">
                            <span class="tag ${turpial.un(color, "")}">${value}</span>
                            <a id="${id}--removeTag" data-elements="${id}" onclick="pencil.form.tags.remove( this )" class="tag is-delete">
                            <span class="is-hidden">${value}</span>
                            </a>
                        </div>
                    </div>`;			
            }
            var html = "";
            helperTags = turpial.find(idTags);
            helperInput.innerText.split(",").forEach(function( value ){
                if(value === ""){ return; }
                html += templateTags(value, turpial.un(props.tagColor, "is-info"));
            });
            turpial.insert(helperTags, html);
            element.value = "";
            if(event !== "attaching"){
                event.preventDefault();
            }				
        }
                
    },
    tagsAttach: function(){
        PencilTagsHelperConstructor
    },
    statusButton: function(target, status){
        if(typeof target === "string"){
            target = turpial.find(target);
        }			
        if(status === "enabled"){
            target.classList.remove("is-loading");
            target.removeAttribute("disabled"); 
        }
        else if(status === "disabled"){ 
            target.classList.add("is-loading");
            target.setAttribute("disabled", true); 
        }
    },
    onEvent: function(props){
        props = turpial.un(props, {});
        props.type = turpial.un(props.type, "string");
        if(props.type == "string"){
            props.target = turpial.find(props.target);
        }
        if(typeof props.event === "undefined"){console.warn("Set an event");return;}
        if(typeof props.render === "undefined"){console.warn("Set a function");return;}
        props.data = turpial.un(props.data, {});
        props.data.target = props.target;
        props.data.event = props.event;
        props.target.addEventListener(props.event, function(){
            props.render(props.data)
        });
    },	
    PushRequiredInputs: function( object ){
        var app = object;
        var elements = document.querySelectorAll(".pencil-required-input");
        [...elements].forEach(function(el){
            app.inputs.push( pencil.form.element(el) );
        })
    },
    retrieve: function(props){
        // NEW 1.1
        // props:
        // 	targets: inputs
        // 	form: form id tag
        // 	
        props.form = turpial.find(props.form);
        var formName = props.form.id;
        let app = this;
        app.formsCount[formName] = {};
        var elements = props.form.querySelectorAll(props.targets);
        [...elements].forEach(function( element ){
            var is_disabled = element.getAttribute("disabled");
            if(is_disabled !== null){ return; }
            if(element.getAttribute("data-array-input") === "true"){
                if(typeof app.formsCount[formName][element.name] !== "object"){
                    app.formsCount[formName][element.name] = [];
                }					
                app.formsCount[formName][element.name].push(element.value);
                return;
            }
            if(element.type === "radio"){
                if(element.checked === false){return;}
                app.formsCount[formName][element.name] = element.value;			
            }
            else if(element.type === "checkbox"){
                if(element.checked === true && element.getAttribute("data-boolean") === "true"){
                    app.formsCount[formName][element.name] = true;
                    return;
                }
                if(typeof app.formsCount[formName][element.name] === "undefined"){
                    app.formsCount[formName][element.name] = {};
                }
                if(element.checked === false && element.getAttribute("data-boolean") === "true"){
                    app.formsCount[formName][element.name] = false;
                    return;
                }
                if(element.checked === false){
                    delete app.formsCount[formName][element.name][element.value];
                    return;
                }else{
                    app.formsCount[formName][element.name][element.value] = element.value;
                }		
            }
            else {					
                app.formsCount[formName][element.name] = element.value;
            }
        })
        return app.formsCount[formName];
    }
}

export {AppForms}